// posturax-ajax-cart.js
import { CartAddEvent } from './events.js';
  async function addToCart(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity || 1) })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'No se pudo agregar al carrito.');
    }
    return res.json();
  }

  async function updateCartCounter() {
    // Solo actualizar el contador del carrito
    try {
      const cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('[data-cart-count], .cart-count-bubble .text').forEach(el => {
        el.textContent = cart.item_count;
        const bubble = el.closest('.cart-count-bubble');
        if (bubble) bubble.classList.toggle('hidden', cart.item_count <= 0);
      });
    } catch (e) {
      console.error('Error actualizando contador:', e);
    }
  }

  // refreshCartUI function removed - cart drawer opens automatically with CartAddEvent

  function initBundleForm(scope) {
    const form = (scope || document).querySelector('#posturax-bundle-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      const variantId = fd.get('id');
      const qty = fd.get('quantity') || 1;
      if (!variantId) return alert('Selecciona una variante.');

      try {
        form.classList.add('is-loading');
        const result = await addToCart(variantId, qty);
        
        // Disparar evento CartAddEvent para que el cart drawer se actualice automáticamente
        document.dispatchEvent(new CartAddEvent(result, form.id, {
          source: 'posturax-bundle-form',
          itemCount: qty,
          variantId: variantId,
          sections: result.sections || {}
        }));
        
        // Actualizar contador del carrito
        await updateCartCounter();
      } catch (err) {
        alert(err.message || 'Error al agregar al carrito.');
      } finally {
        form.classList.remove('is-loading');
      }
    });
  }

document.addEventListener('DOMContentLoaded', () => {
  initBundleForm(document);
});

// Re-init cuando el editor de Shopify re-renderiza la sección
document.addEventListener('shopify:section:load', e => initBundleForm(e.target));
